import React from "react";
import {
    FiCheck,
    FiMinus,
    FiArrowRight,
    FiUserCheck,
    FiCalendar,
    FiPlusCircle,
    FiCrosshair,
    FiShuffle,
    FiShoppingBag,
    FiFileText,
    FiList,
    FiMonitor,
    FiClipboard,
    FiLayers,
} from "react-icons/fi";

import "./sfaComparison.css";

const comparisonData = [
    {
        feature: "Attendance Management",
        icon: <FiUserCheck />,
        tech: "Built-in",
        traditional: "Varies",
    },
    {
        feature: "Planned Outlet Visits",
        icon: <FiCalendar />,
        tech: "Structured",
        traditional: "Available",
    },
    {
        feature: "Unscheduled Visits",
        icon: <FiPlusCircle />,
        tech: "Supported",
        traditional: "Varies",
    },
    {
        feature: "GPS-Aware Field Activity",
        icon: <FiCrosshair />,
        tech: "Location-aware",
        traditional: "Depends on setup",
    },
    {
        feature: "Beat & Route Execution",
        icon: <FiShuffle />,
        tech: "Field focused",
        traditional: "Varies",
    },
    {
        feature: "Order Capture During Visits",
        icon: <FiShoppingBag />,
        tech: "Connected workflow",
        traditional: "Depends on setup",
    },
    {
        feature: "No-Order Outcome Capture",
        icon: <FiFileText />,
        tech: "Structured",
        traditional: "Varies",
    },
    {
        feature: "Outlet Visit History",
        icon: <FiList />,
        tech: "Centralized",
        traditional: "Available",
    },
    {
        feature: "Real-Time Field Visibility",
        icon: <FiMonitor />,
        tech: "Management view",
        traditional: "Depends on setup",
    },
    {
        feature: "Day-End Activity Summary",
        icon: <FiClipboard />,
        tech: "Consolidated",
        traditional: "Varies",
    },
    {
        feature: "Sales & Field Activity",
        icon: <FiLayers />,
        tech: "Connected",
        traditional: "Varies by solution",
    },
];

const SfaComparison = () => {
    return (
        <section className="sfa-comparison-section">
            <div className="sfa-comparison-glow sfa-comparison-glow-left"></div>
            <div className="sfa-comparison-glow sfa-comparison-glow-right"></div>

            <div className="container">
                <div
                    className="sfa-comparison-heading"
                    data-aos="fade-up"
                >
                    <span className="sfa-comparison-kicker">
                        <span className="sfa-comparison-kicker-dot"></span>
                        WHY TECHCOGNICS SFA
                    </span>

                    <h2>
                        Built Around the Way
                        <span> Field Sales Actually Works</span>
                    </h2>

                    <p>
                        Bring attendance, outlet coverage, visit execution,
                        order activity and management visibility together
                        in one connected SFA workflow.
                    </p>
                </div>

                <div
                    className="sfa-comparison-wrapper"
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    <div className="sfa-comparison-topbar">
                        <div className="sfa-comparison-topbar-title">
                            <span className="sfa-comparison-live-dot"></span>

                            <div>
                                <strong>SFA CAPABILITY VIEW</strong>

                                <small>
                                    Field execution comparison
                                </small>
                            </div>
                        </div>

                        <div className="sfa-comparison-count">
                            {String(comparisonData.length).padStart(2, "0")}

                            <span>
                                CAPABILITIES
                            </span>
                        </div>
                    </div>

                    <div className="sfa-comparison-table">
                        <div className="sfa-comparison-header-row">
                            <div className="sfa-comparison-header-feature">
                                Capability
                            </div>

                            <div className="sfa-comparison-header-product">
                                <span className="sfa-header-indicator"></span>
                                TechCognics SFA
                            </div>

                            <div className="sfa-comparison-header-standard">
                                Typical SFA Setup
                            </div>
                        </div>

                        {comparisonData.map((item, index) => (
                            <div
                                className="sfa-comparison-row"
                                key={item.feature}
                                data-aos="fade-up"
                                data-aos-delay={Math.min(index * 30, 240)}
                            >
                                <div className="sfa-comparison-feature-cell">
                                    <span className="sfa-comparison-feature-icon">
                                        {item.icon}
                                    </span>

                                    <div>
                                        <strong>
                                            {item.feature}
                                        </strong>
                                    </div>
                                </div>

                                <div className="sfa-comparison-value-cell sfa-comparison-tech-cell">
                                    <span className="sfa-comparison-status sfa-comparison-status-tech">
                                        <FiCheck />
                                    </span>

                                    <div>
                                        <strong>
                                            {item.tech}
                                        </strong>

                                        <small>
                                            TechCognics SFA
                                        </small>
                                    </div>

                                    <FiArrowRight className="sfa-comparison-arrow" />
                                </div>

                                <div className="sfa-comparison-value-cell sfa-comparison-traditional-cell">
                                    <span className="sfa-comparison-status sfa-comparison-status-standard">
                                        <FiMinus />
                                    </span>

                                    <div>
                                        <strong>
                                            {item.traditional}
                                        </strong>

                                        <small>
                                            Typical setup
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="sfa-comparison-bottom">
                        <div className="sfa-comparison-bottom-accent"></div>

                        <div>
                            <strong>
                                One connected field-sales workflow.
                            </strong>

                            <span>
                                From attendance and visits to sales visibility.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SfaComparison;